import React, { useEffect, useState, useCallback } from "react";
import { useParams } from "react-router-dom";
import api from "../services/api";
import { BsFiletypePdf } from "react-icons/bs";
import { CiCircleMinus, CiCirclePlus } from "react-icons/ci";
import {
  FaEdit,
  FaTrashAlt,
} from "react-icons/fa";
import "./InvoiceReferencePage.css";

const InvoiceReferencePage = () => {
  const { id: businessId } = useParams();

  const [vendors, setVendors] = useState([]);
  const [products, setProducts] = useState([]);
  const [taxRate, setTaxRate] = useState("");
  const [entries, setEntries] = useState([]);
  const [invoices, setInvoices] = useState([]);
  const [expandedRows, setExpandedRows] = useState({}); // invoiceId -> entries[]
  const [editingEntryId, setEditingEntryId] = useState(null);
  const [newEntryMode, setNewEntryMode] = useState({}); // invoiceId: boolean
  const [entryFormData, setEntryFormData] = useState({});
  const [uploadInvoiceType, setUploadInvoiceType] = useState("one-time");
const [uploadVendor, setUploadVendor] = useState("");
const [uploadInvoiceDate, setUploadInvoiceDate] = useState("");
const [invoiceCsvUploadData] = useState([]);
const [showInvoiceCsvPopup, setShowInvoiceCsvPopup] = useState(false);
const [showUploadInstruction, setShowUploadInstruction] = useState(false);
const [showEntryPopup, setShowEntryPopup] = useState(false);
const [popupMode, setPopupMode] = useState("add"); // or "edit"
const [activeInvoiceId, setActiveInvoiceId] = useState(null);
const [activeEntryId, setActiveEntryId] = useState(null);

const [selectedVendorId, setSelectedVendorId] = useState("");


  //const navigate = useNavigate();


        useEffect(() => {
          const fetchData = async () => {
            try {
              const vendorRes = await api.get(`/business/${businessId}/vendors`);
              setVendors(vendorRes.data);

              const productRes = await api.get(`/business/${businessId}/products`);
              setProducts(productRes.data);

              const businessRes = await api.get(`/businesses/${businessId}`);
              if (businessRes.data.sales_tax_rate) {
                setTaxRate(businessRes.data.sales_tax_rate);
              }
            } catch (err) {
              console.error("Error fetching invoice data:", err);
            }
          };

          fetchData();
        }, [businessId]);

        const fetchInvoices = useCallback(async () => {
  try {
    const res = await api.get(`/business/${businessId}/invoices`);
    setInvoices(res.data);
  } catch (err) {
    console.error("Error loading invoices", err);
  }
}, [businessId]); // businessId is a dependency

useEffect(() => {
  fetchInvoices();
}, [fetchInvoices]); // now fetchInvoices is stable


useEffect(() => {
  const onRefresh = () => fetchInvoices();
  window.addEventListener("invoices-refresh", onRefresh);
  return () => window.removeEventListener("invoices-refresh", onRefresh);
}, [fetchInvoices]);



 useEffect(() => {
   const onOpen = () => setShowInvoiceCsvPopup(true);
   window.addEventListener("open-invoice-upload", onOpen);
   return () => window.removeEventListener("open-invoice-upload", onOpen);
 }, []);


      const toggleExpandRow = async (invoiceId) => {
        if (expandedRows[invoiceId]) {
          const newExpanded = { ...expandedRows };
          delete newExpanded[invoiceId];
          setExpandedRows(newExpanded);
        } else {
          try {
            const res = await api.get(`/invoices/${invoiceId}/entries`);
            setExpandedRows({ ...expandedRows, [invoiceId]: res.data });
          } catch (err) {
            console.error("Error loading entries", err);
          }
        }
      };

        const handleAddEntry = () => {
          setEntries((prev) => [
            ...prev,
            {
              id: Date.now(),
              date: "",
              productId: "",
              keyword: "",
              manual: false,
              description: "",
              type: "expense",
              price: "",
              quantity: "",
              amount: 0,
            },
          ]);
        };


        const handleDeleteInvoice = async (invoiceId) => {
  if (!window.confirm("Are you sure you want to delete this invoice?")) return;

  try {
    await api.delete(`/business/${businessId}/invoices/${invoiceId}`);

    setExpandedRows((prev) => {
      const updated = { ...prev };
      delete updated[invoiceId];
      return updated;
    });

    await fetchInvoices();
  } catch (err) {
    console.error("Error deleting invoice:", err);
    alert("Failed to delete invoice.");
  }
};



  const handleSaveNewEntry = async (invoiceId, stayOpen = false) => {
  const {
    entry_date,
    is_manual,
    product_id,
    description,
    type,
    quantity,
    price,
    amount,
  } = entryFormData;

  const selectedProduct = products.find(p => p.id === Number(product_id));

  if (is_manual) {
    if (!description || !amount) {
      alert("Missing required fields for manual entry.");
      return;
    }
  } else {
    if (!product_id || !quantity || !price) {
      alert("Missing required fields for product entry.");
      return;
    }
  }

  let finalAmount = parseFloat(amount);
  if (is_manual && type === "income") {
    finalAmount = -Math.abs(finalAmount);
  }

  let salesTax = 0;
  if (!is_manual && selectedProduct?.taxable) {
    const base = parseFloat(price || 0) * parseFloat(quantity || 0);
    salesTax = parseFloat(((base * parseFloat(taxRate || 0)) / 100).toFixed(2));
  }

  const payload = {
    entry_date: entry_date || null,
    is_manual: !!is_manual,
    product_id: is_manual ? null : product_id,
    description: is_manual ? description : (selectedProduct?.item || null),
    type: type || null,
    quantity: parseFloat(quantity),
    price: parseFloat(price),
    amount: finalAmount,
    sales_tax: salesTax,
  };

  try {
    await api.post(`/invoices/${invoiceId}/entries`, payload);

    const updated = await api.get(`/invoices/${invoiceId}/entries`);
    setExpandedRows(prev => ({ ...prev, [invoiceId]: updated.data }));

    await fetchInvoices();

    if (stayOpen) {
      setEntryFormData({
        is_manual: false,
        entry_date: "",
        product_id: "",
        description: "",
        type: "expense",
        price: "",
        quantity: "",
        amount: "",
      });
    } else {
      setShowEntryPopup(false);
    }
  } catch (err) {
    console.error("Error adding entry:", err);
    alert("Failed to add entry.");
  }
};




   


      const saveEditedEntry = async (invoiceId, entryId) => {
  try {
    const isManual = entryFormData.is_manual === 1 || entryFormData.is_manual === "1";
    const priceRaw = entryFormData.price;
    const qtyRaw = entryFormData.quantity;
    const amountRaw = entryFormData.amount;

    const price = parseFloat(priceRaw);
    const quantity = parseFloat(qtyRaw);
    const hasPrice = !isNaN(price);
    const hasQty = !isNaN(quantity);
    const hasAmount = amountRaw !== undefined && amountRaw !== "" && !isNaN(parseFloat(amountRaw));

    let amount = 0;

    if (isManual) {
      // Priority: if price & quantity exist, compute amount. Else, use manually entered amount
      if (hasPrice && hasQty) {
        amount = parseFloat((price * quantity).toFixed(2));
      } else if (hasAmount) {
        amount = parseFloat(parseFloat(amountRaw).toFixed(2));
      } else {
        alert("Amount is required for manual entry.");
        return;
      }

      if (entryFormData.type === "income") {
        amount = -Math.abs(amount);
      }
    } else {
      if (!hasPrice || !hasQty) {
        alert("Both price and quantity are required for product entries.");
        return;
      }
      amount = parseFloat((price * quantity).toFixed(2));
    }

    const selectedProduct = products.find(p => p.id === Number(entryFormData.product_id));

    // Compute sales tax if needed
    let sales_tax = 0;
    if (!isManual && entryFormData.product_id) {
      const product = products.find(p => p.id === Number(entryFormData.product_id));
      if (product?.taxable) {
        const taxRateFloat = parseFloat(taxRate || 0);
        sales_tax = parseFloat(((price * quantity) * taxRateFloat / 100).toFixed(2));
      }
    }

    const payload = {
      ...entryFormData,
      description: isManual ? entryFormData.description : (selectedProduct?.item || null),
      price: hasPrice ? price : null,
      quantity: hasQty ? quantity : null,
      amount,
      sales_tax,
    };

    await api.put(`/invoices/${invoiceId}/entries/${entryId}`, payload);
    alert("Updated.");
    setEditingEntryId(null);
    const updated = await api.get(`/invoices/${invoiceId}/entries`);
setExpandedRows(prev => ({ ...prev, [invoiceId]: updated.data }));
await fetchInvoices(); // ← re-fetch the invoice list to refresh row colors

  } catch (err) {
    console.error("Failed to update entry:", err);
    alert("Error updating entry.");
  }
};



// REPLACE deleteEntry
const deleteEntry = async (invoiceId, entryId) => {
  if (!window.confirm("Are you sure?")) return;
  try {
    await api.delete(`/invoice-entries/${entryId}`);

    // Refresh entries for THIS invoice (keeps it expanded)
    const updated = await api.get(`/invoices/${invoiceId}/entries`);
    setExpandedRows(prev => ({ ...prev, [invoiceId]: updated.data }));

    // Refresh the invoices list so header row (highlight) updates
    await fetchInvoices();
  } catch (err) {
    console.error("Failed to delete:", err);
    alert("Failed to delete.");
  }
};


     

      const handleGeneratePdf = async (invoiceId, businessId) => {
        try {
          
          const response = await api.get(
            `/invoices/${invoiceId}/print`,
            { responseType: "blob"
          });

          const blob = new Blob([response.data], { type: "application/pdf" });
          const link = document.createElement("a");
          link.href = URL.createObjectURL(blob);
          link.download = `invoice-${invoiceId}.pdf`;
          link.click();
        } catch (err) {
          console.error("Error generating PDF:", err);
          alert("Failed to generate PDF. Please try again.");
        }
      };





const filteredInvoices = selectedVendorId
  ? invoices.filter(inv => String(inv.vendor_id) === String(selectedVendorId))
  : invoices;







        return (
          <div className="inv-ref-container">
            
            
            

            

            {showInvoiceCsvPopup && (
  <>
    <div className="overlay-transactions" onClick={() => setShowInvoiceCsvPopup(false)}></div>
    <div className="popup-transactions">
      <h4>Upload Invoice CSV</h4>

      <select value={uploadVendor} onChange={(e) => setUploadVendor(e.target.value)}>
        <option value="">Select Customer</option>
        {vendors.map((v) => (
          <option key={v.id} value={v.id}>{v.name}</option>
        ))}
      </select>

      <select value={uploadInvoiceType} onChange={(e) => setUploadInvoiceType(e.target.value)}>
        <option value="one-time">One Time</option>
        <option value="open">Open</option>
      </select>

      {uploadInvoiceType === "one-time" && (
        <input
          type="date"
          value={uploadInvoiceDate}
          onChange={(e) => setUploadInvoiceDate(e.target.value)}
        />
      )}

      <button onClick={() => window.invoiceUploadRef.click()}>Choose CSV</button>

      {invoiceCsvUploadData.length > 0 && (
        <>
          <table className="table transactions-table" style={{ marginTop: "10px" }}>
            <thead>
              <tr>
                {Object.keys(invoiceCsvUploadData[0] || {}).map((key, i) => (
                  <th key={i}>{key}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {invoiceCsvUploadData.slice(0, 10).map((row, idx) => (
                <tr key={idx}>
                  {Object.values(row).map((val, i) => (
                    <td key={i}>{val}</td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
          {invoiceCsvUploadData.length > 10 && (
            <p>Showing 10 of {invoiceCsvUploadData.length} rows</p>
          )}
        </>
      )}

      <button
        className="save-pop-up"
        onClick={async () => {
          if (!uploadVendor || !uploadInvoiceType) {
            alert("Please select vendor and invoice type.");
            return;
          }
          if (uploadInvoiceType === "one-time" && !uploadInvoiceDate) {
            alert("Invoice date is required for one-time invoice.");
            return;
          }

          try {
            await api.post(`/business/${businessId}/invoices/upload`, {
              invoice_type: uploadInvoiceType,
              vendor_id: uploadVendor,
              invoice_date: uploadInvoiceType === "one-time" ? uploadInvoiceDate : null,
              entries: invoiceCsvUploadData,
            });
            alert("Upload successful");
            await fetchInvoices();
            setShowInvoiceCsvPopup(false);
          } catch (err) {
            console.error("Upload failed", err);
            alert("Failed to upload invoice.");
          }
        }}
      >
        Submit
      </button>

      <button className="cancel-pop-up" onClick={() => setShowInvoiceCsvPopup(false)}>
        Cancel
      </button>
    </div>
  </>
)}

            

            {entries.length > 0 && (
        <div className="inv-ref-center-icons">
          <span className="inv-ref-icon add-inv-icon" onClick={handleAddEntry}><CiCirclePlus /></span>
          <span className="inv-ref-icon remove-inv-icon" onClick={() => setEntries((prev) => prev.slice(0, -1))}><CiCircleMinus /></span>
        </div>
      )}


           
    

    
{showUploadInstruction && (
  <>
    <div className="overlay-invoice" onClick={() => setShowUploadInstruction(false)}></div>
    <div className="popup-invoice upload-instruction-popup">
      <h4>CSV Upload Instructions</h4>

      <h5 style={{color:"red"}}>REMOVE ANY TOTAL ROWS</h5>

      <div className="sample-csv-instructions">
        {/* Horizontal left arrow */}
        <div className="arrow-left-msg">→ Format your CSV as shown</div>

        

        <div className="sample-table-wrapper">
          {/* Vertical top arrows */}
          <div className="arrow-top-row">
            <div className="arrow-top-msg">↓ Required column</div>
            <div className="arrow-top-msg">↓ Required column</div>
            <div className="arrow-top-msg">↓ Required column</div>
          </div>
          

          <table className="sample-csv-table">
            <thead>
              <tr>
                <th>Date</th>
                <th>Description</th>
                <th>Amount</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>2025-06-12</td>
                <td>Hourly Service Fee</td>
                <td>450.00</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <button
        className="save-pop-up"
        onClick={() => {
          setShowUploadInstruction(false);
          setTimeout(() => window.invoiceUploadRef?.click(), 200);
        }}
      >
        Upload CSV
      </button>

      <button className="cancel-pop-up" onClick={() => setShowUploadInstruction(false)}>
        Cancel
      </button>
    </div>
  </>
)}







  

<div className="inv-ref-filter">
  <select
    id="vendor-filter"
    value={selectedVendorId}
    onChange={(e) => setSelectedVendorId(e.target.value)}
  >
    <option value="">All Customers</option>
    {vendors.map((v) => (
      <option key={v.id} value={v.id}>
        {v.name}
      </option>
    ))}
  </select>
</div>


      
<table className="inv-ref-invoice-table inv-ref-header-table">
  <thead>
    <tr>
      <th className="cust-head">Customer</th>
      <th className="type-head">Type</th>
      <th className="date-head">Date</th>
      <th className="act-head">Actions</th>
    </tr>
  </thead>
</table>


        <div className="inv-table-scroll">
  <table className="inv-ref-invoice-table inv-ref-body-table">
        <tbody>
          {filteredInvoices.map((inv) => (    


            <React.Fragment key={inv.id}>
              <tr
  onClick={() => toggleExpandRow(inv.id)}
  className={`inv-ref-clickable-row ${
    parseFloat(inv.total_balance || "0") <= 0 ? "invoice-row-green" : "invoice-row-red"
  }`}
>


                <td className="cust-head">{inv.vendor_name}</td>
                <td className="type-head">{inv.invoice_type}</td>
                <td className="date-head">{inv.invoice_date ? new Date(inv.invoice_date).toISOString().slice(0, 10) : ""}</td>
                <td className="act-head">
  <div className="invoice-action-buttons">
    <button
      className="pdf-btn"
      onClick={() => handleGeneratePdf(inv.id)}
    >
      <BsFiletypePdf />
    </button>

    <button
      className="pdf-btn"
      onClick={(e) => {
        e.stopPropagation();
        handleDeleteInvoice(inv.id);
      }}
    >
      <FaTrashAlt />
    </button>
  </div>
</td>
              </tr>
              {expandedRows[inv.id] && (
                <tr className="expanded-invoice">
                  <td colSpan={8}>
                  

                  
                    
                    <table className={`inv-ref-subtable ${inv.invoice_type === 'open' ? 'with-date' : 'no-date'}`}>
                      <thead>
                        <tr>
                          {inv.invoice_type === "open" && <th className="sub-date">Date</th>}
                          <th className="sub-desc">Description</th>
                          <th className="sub-qty">Quantity</th>
                          <th className="sub-price">Price</th>
                          <th className="sub-amount">Amount</th>
                          <th className="sub-type">Type</th>
                          <th className="sub-action">Actions</th>
                        </tr>
                      </thead>
                      
                      <tbody>
        {expandedRows[inv.id].map((entry, idx) => {
        const isEditing = editingEntryId === entry.id;

        

        return (
          <tr key={entry.id}>
            <td colSpan="7">
              {isEditing ? (
  <div className="inv-ref-entry-box">
    {/* Show entry_date only for open invoices */}
    {inv.invoice_type === "open" && (
      <div>
      <label>Date</label>
      <input
        placeholder="mm/dd/yy"
        type="date"
        value={entryFormData.entry_date || ""}
        onChange={(e) =>
          setEntryFormData({ ...entryFormData, entry_date: e.target.value })
        }
      />
      </div>
    )}

    {/* Manual Entry */}
    {entryFormData.is_manual === 1 || entryFormData.is_manual === "1" ? (
      <>
        <input
        type="text"
          placeholder="Description"
          value={entryFormData.description || ""}
          onChange={(e) =>
            setEntryFormData({ ...entryFormData, description: e.target.value })
          }
        />
        <select
          value={entryFormData.type || "expense"}
          onChange={(e) =>
            setEntryFormData({ ...entryFormData, type: e.target.value })
          }
        >
          <option value="income">Income</option>
          <option value="expense">Expense</option>
        </select>
        <input
          type="number"
          placeholder="Price"
          value={entryFormData.price || ""}
          onChange={(e) => {
            const price = parseFloat(e.target.value || 0);
            const quantity = parseFloat(entryFormData.quantity || 0);
            setEntryFormData({
              ...entryFormData,
              price,
              amount: !isNaN(price * quantity) ? (price * quantity).toFixed(2) : "",
            });
          }}
        />
        <input
          type="number"
          placeholder="Qty"
          value={entryFormData.quantity || ""}
          onChange={(e) => {
            const quantity = parseFloat(e.target.value || 0);
            const price = parseFloat(entryFormData.price || 0);
            setEntryFormData({
              ...entryFormData,
              quantity,
              amount: !isNaN(price * quantity) ? (price * quantity).toFixed(2) : "",
            });
          }}
        />
        <input
          type="number"
          placeholder="Amount"
          value={entryFormData.amount || ""}
          onChange={(e) =>
            setEntryFormData({ ...entryFormData, amount: e.target.value })
          }
        />
      </>
    ) : (
      <>
        <select
          value={entryFormData.product_id || ""}
          onChange={(e) => {
            const prod = products.find((p) => p.id === Number(e.target.value));
            const price = prod ? parseFloat(prod.price) : 0;
            const quantity = parseFloat(entryFormData.quantity || 0);
            const amount = !isNaN(price * quantity) ? (price * quantity).toFixed(2) : "";

            setEntryFormData({
              ...entryFormData,
              product_id: e.target.value,
              price,
              amount,
            });
          }}
        >
          <option value="">Select Product</option>
          {products.map((prod) => (
            <option key={prod.id} value={prod.id}>
              {prod.item}
            </option>
          ))}
        </select>
        <input
          type="number"
          placeholder="Qty"
          value={entryFormData.quantity || ""}
          onChange={(e) => {
            const quantity = parseFloat(e.target.value || 0);
            const price = parseFloat(entryFormData.price || 0);
            const amount = !isNaN(price * quantity) ? (price * quantity).toFixed(2) : "";
            setEntryFormData({
              ...entryFormData,
              quantity,
              amount,
            });
          }}
        />
        <input
          type="number"
          placeholder="Amount"
          value={entryFormData.amount || ""}
          onChange={(e) =>
            setEntryFormData({ ...entryFormData, amount: e.target.value })
          }
        />
      </>
    )}

    <button onClick={() => saveEditedEntry(inv.id, entry.id)}>💾 Save</button>
    <button onClick={() => setEditingEntryId(null)}>❌ Cancel</button>
  </div>
) : (
  <table className="inv-ref-subtable">
    <tbody>
      <tr>
        {inv.invoice_type === "open" && (
          <td className="sub-date">
            {entry.entry_date
              ? new Date(entry.entry_date).toLocaleDateString()
              : "N/A"}
          </td>
        )}
        <td className="sub-desc">{entry.description || `Product #${entry.product_id}`}</td>
        <td className="sub-qty">{entry.quantity}</td>
        <td className="sub-price">{entry.price}</td>
        <td className="sub-amount">{entry.amount}</td>
        <td className="sub-type">{entry.type}</td>
        <td className="sub-action">
          <button
  className="ed-btn"
  onClick={() => {
    setPopupMode("edit");
    setActiveInvoiceId(inv.id);
    setActiveEntryId(entry.id);
    setEntryFormData({
      ...entry,
      is_manual: entry.is_manual === 1 || entry.is_manual === "1" ? 1 : 0,
      entry_date: entry.entry_date ? new Date(entry.entry_date).toISOString().slice(0, 10) : "",
    });
    setShowEntryPopup(true);
  }}
>
  <FaEdit />
</button>
<button className="del-btn" onClick={() => deleteEntry(inv.id, entry.id)}>
  <FaTrashAlt />
</button>


        </td>
      </tr>
    </tbody>
  </table>
)}

            </td>
          </tr>
        );
      })}





      {showEntryPopup && (
  <>
    <div className="overlay-invoice" onClick={() => setShowEntryPopup(false)}></div>
    <div className="popup-invoice entry-popup">
      <h3>{popupMode === "edit" ? "Edit Entry" : "Add Entry"}</h3>

      <div className="entry-mode-switch">
  <button
    type="button"
    className={entryFormData.is_manual ? '' : 'active'}
    onClick={() =>
      setEntryFormData({
        ...entryFormData,
        is_manual: false,
        description: "",
        product_id: "",
        price: "",
        quantity: "",
        amount: "",
      })
    }
  >
    Product
  </button>
  <button
    type="button"
    className={entryFormData.is_manual ? 'active' : ''}
    onClick={() =>
      setEntryFormData({
        ...entryFormData,
        is_manual: true,
        description: "",
        product_id: "",
        price: "",
        quantity: "",
        amount: "",
      })
    }
  >
    Manual
  </button>
</div>


      {/* Entry Date (only for open invoices) */}
      {invoices.find(inv => inv.id === activeInvoiceId)?.invoice_type === "open" && (
        <div className="inv-date-entry-ref">
        <label>Date</label>
        <input
          type="date"
          value={entryFormData.entry_date || ""}
          onChange={(e) => setEntryFormData({ ...entryFormData, entry_date: e.target.value })}
        />
        </div>
      )}

      


      {/* Entry Fields */}
      {entryFormData.is_manual ? (
        <>
          <input
            type="text"
            placeholder="Description"
            value={entryFormData.description}
            onChange={(e) => setEntryFormData({ ...entryFormData, description: e.target.value })}
          />
          <select
            value={entryFormData.type}
            onChange={(e) => setEntryFormData({ ...entryFormData, type: e.target.value })}
          >
            <option value="income">Income</option>
            <option value="expense">Expense</option>
          </select>
          <input
            type="number"
            placeholder="Price"
            value={entryFormData.price}
            onChange={(e) => {
              const price = parseFloat(e.target.value || 0);
              const qty = parseFloat(entryFormData.quantity || 0);
              setEntryFormData({
                ...entryFormData,
                price,
                amount: !isNaN(price * qty) ? (price * qty).toFixed(2) : "",
              });
            }}
          />
          <input
            type="number"
            placeholder="Quantity"
            value={entryFormData.quantity}
            onChange={(e) => {
              const qty = parseFloat(e.target.value || 0);
              const price = parseFloat(entryFormData.price || 0);
              setEntryFormData({
                ...entryFormData,
                quantity: qty,
                amount: !isNaN(price * qty) ? (price * qty).toFixed(2) : "",
              });
            }}
          />
        </>
      ) : (
        <>
          <select
            value={entryFormData.product_id}
            onChange={(e) => {
              const selected = products.find((p) => p.id === Number(e.target.value));
              const price = selected ? parseFloat(selected.price) : 0;
              const qty = parseFloat(entryFormData.quantity || 0);
              setEntryFormData({
                ...entryFormData,
                product_id: e.target.value,
                price,
                amount: !isNaN(price * qty) ? (price * qty).toFixed(2) : "",
              });
            }}
          >
            <option value="">Select Product</option>
            {products.map((prod) => (
              <option key={prod.id} value={prod.id}>
                {prod.item}
              </option>
            ))}
          </select>
          <input
            type="number"
            placeholder="Quantity"
            value={entryFormData.quantity}
            onChange={(e) => {
              const qty = parseFloat(e.target.value || 0);
              const price = parseFloat(entryFormData.price || 0);
              setEntryFormData({
                ...entryFormData,
                quantity: qty,
                amount: !isNaN(price * qty) ? (price * qty).toFixed(2) : "",
              });
            }}
          />
        </>
      )}

      <input
        type="number"
        placeholder="Amount"
        value={entryFormData.amount}
        onChange={(e) => setEntryFormData({ ...entryFormData, amount: e.target.value })}
      />

      {/* Save Buttons */}
      <div className="popup-actions">
  {/* Normal Save */}
  <button
    className="save-invoice"
    onClick={async () => {
      if (popupMode === "add") {
        await handleSaveNewEntry(activeInvoiceId, false); // ⬅️ new arg: stayOpen = false
      } else {
        await saveEditedEntry(activeInvoiceId, activeEntryId);
      }
      setShowEntryPopup(false);
    }}
  >
    Save
  </button>

  {/* Save and Add Another */}
  {popupMode === "add" && (
    <button
      className="add-another-inv"
      onClick={async () => {
        await handleSaveNewEntry(activeInvoiceId, true); // ⬅️ stayOpen = true
      }}
    >
      Save & Add Another
    </button>
  )}

  <button className="cancel-inv" onClick={() => setShowEntryPopup(false)}>
    Cancel
  </button>
</div>

    </div>
  </>
)}



       {newEntryMode[inv.id] && (
  <tr>
    <td colSpan="8">
      <div className="inv-ref-entry-box">
        <label>
          <input
            type="checkbox"
            checked={entryFormData.is_manual || false}
            onChange={(e) =>
              setEntryFormData({
                ...entryFormData,
                is_manual: e.target.checked,
                // reset relevant fields
                description: "",
                product_id: "",
                price: "",
                quantity: "",
                amount: "",
              })
            }
          />
          Manual Entry
        </label>

        {/* Only show date input for open invoices */}
        {inv.invoice_type === "open" && (
          <input
            type="date"
            value={entryFormData.entry_date || ""}
            onChange={(e) =>
              setEntryFormData({
                ...entryFormData,
                entry_date: e.target.value,
              })
            }
          />
        )}

        {entryFormData.is_manual ? (
          <>
            <input
              type="text"
              placeholder="Description"
              value={entryFormData.description || ""}
              onChange={(e) =>
                setEntryFormData({
                  ...entryFormData,
                  description: e.target.value,
                })
              }
            />
            <select
              value={entryFormData.type || ""}
              onChange={(e) =>
                setEntryFormData({
                  ...entryFormData,
                  type: e.target.value,
                })
              }
            >
              <option value="">Select Type</option>
              <option value="income">Income</option>
              <option value="expense">Expense</option>
            </select>
            <input
              type="number"
              placeholder="Price"
              value={entryFormData.price || ""}
              onChange={(e) => {
                const price = parseFloat(e.target.value || 0);
                const qty = parseFloat(entryFormData.quantity || 0);
                setEntryFormData({
                  ...entryFormData,
                  price,
                  amount: !isNaN(price * qty) ? (price * qty).toFixed(2) : "",
                });
              }}
            />
            <input
              type="number"
              placeholder="Qty"
              value={entryFormData.quantity || ""}
              onChange={(e) => {
                const qty = parseFloat(e.target.value || 0);
                const price = parseFloat(entryFormData.price || 0);
                setEntryFormData({
                  ...entryFormData,
                  quantity: qty,
                  amount: !isNaN(price * qty) ? (price * qty).toFixed(2) : "",
                });
              }}
            />
          </>
        ) : (
          <>
            <select
              value={entryFormData.product_id || ""}
              onChange={(e) => {
                const selected = products.find((p) => p.id === Number(e.target.value));
                const price = selected ? parseFloat(selected.price) : 0;
                const qty = parseFloat(entryFormData.quantity || 0);
                setEntryFormData({
                  ...entryFormData,
                  product_id: e.target.value,
                  price,
                  amount: !isNaN(price * qty) ? (price * qty).toFixed(2) : "",
                });
              }}
            >
              <option value="">Select Product</option>
              {products.map((prod) => (
                <option key={prod.id} value={prod.id}>
                  {prod.item}
                </option>
              ))}
            </select>
            <input
              type="number"
              placeholder="Qty"
              value={entryFormData.quantity || ""}
              onChange={(e) => {
                const qty = parseFloat(e.target.value || 0);
                const price = parseFloat(entryFormData.price || 0);
                setEntryFormData({
                  ...entryFormData,
                  quantity: qty,
                  amount: !isNaN(price * qty) ? (price * qty).toFixed(2) : "",
                });
              }}
            />
          </>
        )}

        <input
  type="number"
  placeholder="Amount"
  value={entryFormData.amount || ""}
  onChange={(e) =>
    setEntryFormData({
      ...entryFormData,
      amount: e.target.value,
    })
  }
/>


        <button onClick={() => handleSaveNewEntry(inv.id)}>💾</button>
        <button
          onClick={() =>
            setNewEntryMode({ ...newEntryMode, [inv.id]: false })
          }
        >
          ❌
        </button>
      </div>
    </td>
  </tr>
)}


    <tr>
          <td colSpan="8">
           <button
  onClick={() => {
    setPopupMode("add");
    setActiveInvoiceId(inv.id);
    setActiveEntryId(null);
    setEntryFormData({
      is_manual: false,
      entry_date: "",
      description: "",
      type: "expense",
      product_id: "",
      quantity: "",
      price: "",
      amount: "",
    });
    setShowEntryPopup(true);
  }}
>
  <CiCirclePlus /> Add Entry
</button>

          </td>
        </tr>


        
      </tbody>
  
       </table>
                    <div className="total-row-invoice">
                      {inv.invoice_type === "open" && <td></td>}
                      <div className="sub-total">
                        Subtotal:
                      </div>
                      <div style={{ fontWeight: "bold", marginLeft:"10px" }}>
                        {expandedRows[inv.id]
                          .reduce((acc, curr) => acc + parseFloat(curr.amount || 0), 0)
                          .toFixed(2)}
                      </div>

                      <div className="sub-tax">Tax:</div>
                      <div style={{ fontWeight: "bold", marginLeft:"10px"  }}>
                        {expandedRows[inv.id]
                          .reduce((acc, curr) => acc + parseFloat(curr.sales_tax || 0), 0)
                          .toFixed(2)}
                      </div>

                      <div className="total-invoice">Total:</div>
                      <div style={{ fontWeight: "bold", marginLeft:"10px"  }}>
                        {expandedRows[inv.id]
                          .reduce((acc, curr) =>
                            acc +
                            parseFloat(curr.amount || 0) +
                            parseFloat(curr.sales_tax || 0),
                            0
                          )
                          .toFixed(2)}
                      </div>
                    </div>
                  </td>
                </tr>
              )}
            </React.Fragment>
          ))}
        </tbody>
      </table>
      </div>


    </div>
  );
};

export default InvoiceReferencePage;




